module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-1-75d6e41573481b5113a4c2c7ceb08323.svg";